module.exports = __webpack_public_path__ + "static/demo-apply-bef8a2b7283196e26d7cc45340443922.svg";